$( document ).ready(function() {
  // HOME PAGE COLLECTION FILTER
  $('.collections__options').click(function () {
      $(this).toggleClass('active');
      $(this).children('.collections__options--list').fadeToggle();
   });
  
  // SHIPPING PAGE
  var multipleTextblocks = $('#page__shipping-and-returns .block__rich_text').length;
  if (multipleTextblocks > 1) {
    $('#page__shipping-and-returns .block__rich_text').wrapAll('<div class="all__text-block--wrapper block__custom--page"></div>');
  }
  $('#page__shipping-and-returns .all__text-block--wrapper .block__rich_text').removeClass('block__custom--page');
  
  // LANDING PAGE IMAGE TEXT BLOCK
  var multipleImageTextblock = $('.multiple__content--carousel').length;
  if (multipleImageTextblock > 1) {
    $('.multiple__content--carousel').wrapAll('<div class="all__image--text-block--wrapper block__custom--page"></div>');
    $('.all__image--text-block--wrapper .multiple__content--carousel').removeClass('block__custom--page');
  }
  
  $('.all__image--text-block--wrapper').slick({
    arrows: true,
    prevArrow: '<div class="slider-arrow slider-prev"><i class="fa fa-chevron-left altas-slide-prev" style="position:absolute;"></i></div>',
    nextArrow: '<div class="slider-arrow slider-next"><i class="fa fa-chevron-right altas-slide-next"></i></div>'
  });

  // PRODUCT PAGE CAROUSEL
  $('.thumbnails-wrapper .product-single__thumbnails-product-template').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    prevArrow: '<div class="slider-arrow slider-prev"><i class="fa fa-chevron-left"></i></div>',
    nextArrow: '<div class="slider-arrow slider-next"><i class="fa fa-chevron-right"></i></div>'
  }); 
  
  // CONTACT PAGE
  $('#shopify-section-page-contact .fa-comments').click(function(){
  	olark('api.box.expand');
  });
  
  // FILTER MOBILE
  $('.sidebar-label .filter__header').click(function () {
      $(this).parent().addClass('active');
      $(this).parent().next('.sidebar').slideDown();
      $(this).next('.filter__close').click(function (){
         $(this).parent().removeClass('active');
         $('.sidebar').slideUp();
      });
   });
  $('.tabsRD2 li').click(function(){
    $('.tabsRD2 li').removeClass('active');
    $(this).addClass('active');
    var divToShow = '#c_'+$(this).attr('id');
    $('.tabs_content .tabContent').removeClass('active');
    $(divToShow).addClass('active');
  });
  $('#all-cat').click(function(){
    $('#category-widget').css('max-height', 'unset');
    $(this).hide();
  })
});
